<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
</script>
<template>
  <div>
    <index-navbar/>
    <section
        class="header relative pt-16 items-center flex h-screen max-h-860-px"
    >
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
          <div class="pt-32 sm:pt-0">
            <h1 class="font-semibold text-4xl text-blueGray-600">
              PNSCA
            </h1>
            <p class="mt-4 text-lg leading-relaxed text-blueGray-500" style="text-align: justify;font-size:18px">
              <strong>PNSCA (Perinatal Single-Cell Atlas)</strong> is a comprehensive single-cell transcriptome database
              specifically designed for placental and decidual tissues derived from human perinatal diseases. PNSCA
              serves not only as a manually curated repository of single-cell transcriptomic data but also enables
              sample-level exploration of gene expression profiles across diverse cell types. <br>The current release
              comprises 160 single-cell samples, encompassing nearly 1.5 million cells and yielding 370 distinct cell
              clusters based on gene expression profiling. The database covers nearly all categories of perinatal
              disorders, including fetal growth restriction, preeclampsia, recurrent implantation failure, early
              miscarriage, intrahepatic cholestasis of pregnancy, COVID-19 infection, microbial infections, and placenta
              accreta spectrum disorders, among others.
            </p>
          </div>
        </div>
        <div class="w-full lg:w-6/12 xl:w-6/12 px-4">
          <img src="@/assets/pic/introduce.png" style="width: 100%">
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
